import React from "react";
import { convertTimestampToDate } from "../../../../utils";
import "../styles/ProjectDetailsScreen.css";
import ProjectDetailsBox from "./ProjectDetailsBox";
import ProjectCheckpoints from "./ProjectCheckpoints";

export default function ActiveProjectDetails({ project }) {
  const getMilestoneStatusLabel = status => {
    switch (status) {
      case "waiting_approval":
        return { text: "Waiting For Approval", className: "statusWaiting" };
      case "completed":
        return { text: "Completed", className: "statusCompleted" };
      case "not_completed":
      default:
        return { text: "Not Completed", className: "statusPending" };
    }
  };

  return (
    <div className="projectDetailsContainer">
      {/* Project ID and title */}
      <div className="headerWithBack">
        <div className="headerProjectTitle">{project.title}</div>
        <div className="projectId">#{project.projectId}</div>
      </div>

      {/* Project progress indicator */}
      <div style={{ display: "flex", alignItems: "center", marginTop: "2vh" }}>
        <div
          style={{
            marginRight: "1vw",
            fontFamily: "Poppins, sans-serif",
            fontWeight: 600,
            fontSize: "1.8vh",
          }}
        >
          {project.currentProgress}%
        </div>
        <div className="progressBar" style={{ flex: 1, marginRight: "1vw" }}>
          <div
            className="progressFill"
            style={{ width: `${project.currentProgress}%` }}
          ></div>
        </div>
        <div
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: 600,
            fontSize: "1.8vh",
          }}
        >
          In Progress
        </div>
      </div>

      {/* Project details box */}
      <ProjectDetailsBox project={project} />

      {/* Checkpoints section */}
      <ProjectCheckpoints
        checkpoints={project.checkpoints}
        projectPriceFinalized={project.priceFinalized}
      />

      {/* Bills section */}
      <div className="projectDetailsBox">
        <div className="projectDetailsHeader">Bills</div>

        {project.bills && project.bills.length > 0 ? (
          <>
            {project.bills.map((bill, index) => (
              <div className="bidCard" key={index}>
                <div className="bidHeader">
                  <div className="bidMerchantName">
                    {project.merchFinalizedData.displayName}
                  </div>
                  <div className="bidAmount">{bill.amount} SAR</div>
                </div>
                <div className="bidContent">{bill.items}</div>
                <div className="bidDate">
                  {convertTimestampToDate(bill.timestamp)}
                </div>

                {/* Bill Images */}
                {bill.images && bill.images.length > 0 && (
                  <div className="billImagesContainer">
                    <div className="projectImagesGrid">
                      {bill.images.map((image, index) => (
                        <div key={index} className="projectImageContainer">
                          <img
                            src={image}
                            alt="Bill"
                            className="projectImage"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}

            <div className="billSummary">
              <div className="billSummaryLabel">Money Used by far</div>
              <div className="billSummaryValue">
                {project.totalBillAmount}/{project.priceFinalized} SAR (vat
                excl.)
              </div>
            </div>
          </>
        ) : (
          <div className="emptyState">
            <div className="emptyStateText">No bills added</div>
          </div>
        )}
      </div>

      <style jsx>{`
        .projectDetailsContainer {
          padding: 24px;
          background-color: #fff;
          border-radius: 8px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
        }

        .headerWithBack {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 24px;
        }

        .headerProjectTitle {
          font-size: 24px;
          font-weight: 600;
          color: #333;
        }

        .projectId {
          font-size: 16px;
          color: #8c8c8c;
          font-weight: 500;
        }
      `}</style>
    </div>
  );
}
